// extracted by mini-css-extract-plugin
export default {"FeaturedProducts":"FeaturedProducts_FeaturedProducts__zXsTm","categoryDesc":"FeaturedProducts_categoryDesc__VgZHt","screenSm":"FeaturedProducts_screenSm__a-3Q7"};